// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__3L21O","tools":"Skills_tools__YOs+O","grid":"Skills_grid__wT6KO"};